import { render, staticRenderFns } from "./actionButtons.vue?vue&type=template&id=60814640&scoped=true&"
import script from "./actionButtons.vue?vue&type=script&lang=js&"
export * from "./actionButtons.vue?vue&type=script&lang=js&"
import style0 from "./actionButtons.vue?vue&type=style&index=0&id=60814640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60814640",
  null
  
)

export default component.exports